import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'À emporter',
  [OrderMethod.Delivery]: 'Livraison',
  [OrderMethod.OnSite]: 'Commande à table',
};
